// Firebase configuration
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

// Firebase configuration (Updated to correct project: wallz-301b3)
const firebaseConfig = {
  apiKey: "AIzaSyAil518ZrFQ0gmhTxd431rQ0NwBizUhhLI",
  authDomain: "wallz-301b3.firebaseapp.com",
  databaseURL: "https://wallz-301b3-default-rtdb.firebaseio.com",
  projectId: "wallz-301b3",
  storageBucket: "wallz-301b3.firebasestorage.app",
  messagingSenderId: "994538618401",
  appId: "1:994538618401:web:3d93a6e1e6a9027c8bad60",
  measurementId: "G-RSDL92HPFX"
};

// Initialize Firebase (Check if already initialized to prevent error)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;

// Instructions for setting up Firebase:
/*
1. Go to https://console.firebase.google.com/
2. Create a new project or select existing one
3. Go to Project Settings → General
4. Scroll down to "Your apps" section
5. Click "Add app" → Web app
6. Register your app with a nickname
7. Copy the config object and replace the values above
8. Go to Firestore Database → Create database
9. Choose "Start in test mode" for now
10. Select a location for your database
11. Your Firebase setup is complete!
*/
